import {path, pipe, split} from 'ramda';

/**
 * Get by dot notation from object or array.
 */
export const dotGet: any = pipe(split('.'), path);

